import { c as _c } from "react/compiler-runtime";
import { ThemeProvider } from '@newfront-insurance/core-ui/v2';
import type { AuthProviderContext } from '@newfront-insurance/next-auth';
import type { Provider } from '@newfront-insurance/react-provision';
import type { JSX, PropsWithChildren } from 'react';
import type { ErrorCallback } from './components/error-boundary';
import { LayoutConfigProvider } from './config';
import type { AppType } from './metadata/apps';
interface Props {
  apiBasePath: string;
  authProvider: Provider<AuthProviderContext>;
  currentApp: AppType;
  legacyAppBaseUrl: string;
  logoutRedirect: string;
  onError?: ErrorCallback;
}

/**
 * Add this provider to _app to enable the use of all of the hooks.
 */
export function AdminLayoutProvider(props) {
  const $ = _c(8);
  const {
    apiBasePath,
    children,
    authProvider,
    currentApp,
    legacyAppBaseUrl,
    logoutRedirect,
    onError
  } = props;
  let t0;
  if ($[0] !== apiBasePath || $[1] !== authProvider || $[2] !== children || $[3] !== currentApp || $[4] !== legacyAppBaseUrl || $[5] !== logoutRedirect || $[6] !== onError) {
    t0 = <ThemeProvider attribute="class" defaultTheme="light" disableTransitionOnChange={true}><LayoutConfigProvider authProvider={authProvider} apiBasePath={apiBasePath} currentApp={currentApp} legacyAppBaseUrl={legacyAppBaseUrl} logoutRedirect={logoutRedirect} onError={onError}>{children}</LayoutConfigProvider></ThemeProvider>;
    $[0] = apiBasePath;
    $[1] = authProvider;
    $[2] = children;
    $[3] = currentApp;
    $[4] = legacyAppBaseUrl;
    $[5] = logoutRedirect;
    $[6] = onError;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  return t0;
}